export const GOOGLE_MAPS_API_KEY = 'AIzaSyAi2E0cDW_isBjE7mQOqMHPviEstSwCQO4';
